import { forwardRef } from 'react';

import { cva } from 'class-variance-authority';

import { cn } from '@/shared/utils';

import { Label } from '@/components/ui/label';

const inputVariants = cva(
  [
    'flex h-14 w-full rounded-[16px] border bg-white bg-opacity-10',
    'px-5 py-2 text-lg ring-offset-background transition-all',
    'file:border-0 file:bg-transparent file:text-sm file:font-medium',
    'placeholder:font-light placeholder:text-white placeholder:text-opacity-20',
    'hover:border-opacity-60',
    'focus-visible:border-opacity-60 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-1',
    'disabled:cursor-not-allowed disabled:opacity-50',
  ],
  {
    variants: {
      state: {
        default: 'border-white border-opacity-20',
        error: 'border-red-500',
      },
    },
    defaultVariants: {
      state: 'default',
    },
  }
);

const Input = forwardRef(({ className, type, state, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(inputVariants({ state }), className)}
      ref={ref}
      {...props}
    />
  );
});
Input.displayName = 'Input';

const InputWithLabel = forwardRef(
  ({ label, inputClass, className, error, ...props }, ref) => {
    const state = error ? 'error' : 'default';

    return (
      <div
        className={cn('grid h-[118px] w-full items-center gap-2.5', className)}
      >
        <Label htmlFor={props.id} className="text-secondary">
          {label}
        </Label>
        <Input ref={ref} className={inputClass} state={state} {...props} />
        <p className="-mt-2 h-6 text-red-500">{error}</p>
      </div>
    );
  }
);
InputWithLabel.displayName = 'InputWithLabel';

export { Input, InputWithLabel };
